import { useExport } from '@/features/DataHub/modules/Export/context/ExportContext';

export const useExportSettingsContext = () => {
  const { exportSettings } = useExport();
  const { dateRangeType, includeMetadata, from, to, period, periodNumber } = exportSettings;
  return { exportType: dateRangeType, includeMetadata, from, to, period, periodNumber };
};
